import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';

import * as _ from 'lodash';

import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';
import { CountryService } from './../../rest/api/country.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, AfterViewInit {
  @ViewChild('countryText') countryText: ElementRef;
  @ViewChildren('dropDownDiv') private dropDownDivList: QueryList<ElementRef>;
  showDropDown = false;
  registerForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  clientId: any;
  clientSecret: any;

  loading = true;
  countryData: any;
  filteredCountryData: any;
  selectedCountry: any;

  constructor(
    public fb: FormBuilder,
    public memberService: MemberService,
    public helperService: HelperService,
    public countryService: CountryService,
    public title: Title
  ) {
    this.title.setTitle('Register | Betaspace');
    this.clientId = environment.clientId;
    this.clientSecret = environment.clientSecret;
  }

  ngOnInit() {
    this.showDropDown = true;
    this.getCountryData();
    this.registerFormInit();
  }

  ngAfterViewInit() {
    this.dropDownDivList.changes.subscribe((list: QueryList<ElementRef>) => {
      if (list.length > 0) {
        list.first.nativeElement.focus();
      }
    });
  }

  showDropDowns() {
    this.showDropDown = true;
  }

  getCountryData() {
    this.countryService.getCountryName().subscribe((res: any) => {
      if (res) {
        this.countryData = res.data ? res.data : [];
        this.filteredCountryData = res.data ? res.data : [];
      } else {
        this.countryData = [];
        this.filteredCountryData = [];
      }
      const country = this.countryData ? _.find(this.countryData, { alpha_code: 'JP' }) : undefined;
      if (country) {
        this.selectedCountry = country;
      } else {
        this.selectedCountry = this.countryData && this.countryData[0] ? this.countryData[0] : undefined;
      }
      this.loading = false;
    }, err => {
      this.countryData = [];
      this.loading = false;
    });
  }

  changeCountry(country) {
    if (this.countryText) {
      this.countryText.nativeElement.value = '';
      this.filteredCountryData = this.countryData;
    }
    this.selectedCountry = country;
  }

  searchCountry(event) {
    if (event.target.value === '') {
      this.filteredCountryData = this.countryData;
    } else {
      this.filteredCountryData = _.filter(this.filteredCountryData, _.flow(
        _.identity,
        _.values,
        _.join,
        _.toLower,
        _.partialRight(_.includes, event.target.value)
      ));
    }
  }

  registerFormInit() {
    this.registerForm = this.fb.group({
      first_name: ['', [Validators.required, Validators.maxLength(40)]],
      last_name: ['', [Validators.required, Validators.maxLength(40)]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10,11}$/)]],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
      // country_code: ['', [Validators.required]],
      company_name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(40)]]
    });
  }

  submit(value) {
    if (!this.registerForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.country_code = this.selectedCountry.alpha_code;
    this.registerMembers(data);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  registerMembers(data) {
    data.client_id = this.clientId;
    data.client_secret = this.clientSecret;
    data = this.helperService.updateJsonFormat(data);
    this.memberService.registerMember(data).subscribe(response => {
      this.resetForm();
      this.successMsg = 'Verification email has been sent to your email.';
      // setTimeout(() => {
      //   this.resetErrors();
      // }, 5000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.registerForm.reset();
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Unable to register at this time.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
     return false;
    }
    if (e.which === 0) {
     return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
   }
}
